import { useEffect, useState } from 'react';

/**
 * Shared popup state for the paginated filter items: the raw search input, a
 * debounced copy for the API, and a latch that only enables fetching once the
 * popup has been opened for the first time.
 */
export function useFilterPopupState(): {
    search: string;
    setSearch: (query: string) => void;
    debouncedSearch: string;
    hasOpened: boolean;
    onOpenChanged: (open: boolean) => void;
} {
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [hasOpened, setHasOpened] = useState(false);

    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedSearch(search.trim());
        }, 300);
        return () => clearTimeout(handle);
    }, [search]);

    function onOpenChanged(open: boolean) {
        if (open) {
            setHasOpened(true);
        }
    }

    return {
        search,
        setSearch,
        debouncedSearch,
        hasOpened,
        onOpenChanged
    };
}
